/* eslint-disable no-console */

import * as Sentry from '@sentry/browser';
// import { Integrations } from '@sentry/tracing';
// import gbiHistory from '../goodBeefIndex/gbiHistory';
// import bbHistory from '../beefbook/beefbookHistory';
import { isGBI } from './site';

let doLog = false;
// const history = isGBI() ? gbiHistory : bbHistory;

let projectId = isGBI() ? '5217883' : '5218041';
const key = isGBI() ?
  '5cc603f80e754587b78a7ef0c4709946' :
  'c39d8f8557804a238daa9845105d04b6';

export const init = () => {
  if (window.location.hostname !== 'localhost') {
    doLog = true;
    console.log('initialising logging');
    Sentry.init({
      // eslint-disable-next-line max-len
      dsn: `https://${key}@o385345.ingest.sentry.io/${projectId}`,
      // integrations: [new Integrations.BrowserTracing({
      //   routingInstrumentation: Sentry.reactRouterV4Instrumentation(history)
      // })],
      tracesSampleRate: 1.0
    });
  }
};

export const captureException = (error) => {
  if (doLog) {
    console.log(error.toString());
    Sentry.captureException(error);
  } else {
    console.log(error);
  }
};
